"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "8ebe622",
    "raw": "v3.6.0",
    "semverString": "3.6.0"
};
//# sourceMappingURL=version.js.map